var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMicrophoneSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.418 7.582-7.28 7.28a4.776 4.776 0 0 1-1.56-3.52v-4.92c0-2.06 1.4-3.77 3.3-4.26.19-.05.37.11.37.3v1.54c0 .41.34.75.75.75s.75-.34.75-.75v-1.54c0-.19.18-.35.37-.3 1.9.49 3.3 2.2 3.3 4.26v1.16zM19.812 11.401c0 4.07-3.13 7.42-7.11 7.77v2.13c0 .39-.31.7-.7.7-.39 0-.7-.31-.7-.7v-2.13c-1.09-.1-2.12-.42-3.04-.93l1.03-1.03c.82.38 1.74.6 2.71.6 3.54 0 6.42-2.88 6.42-6.41v-1.59c0-.38.31-.69.7-.69.38 0 .69.31.69.69v1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.418 11.528c0 2.58-2.22 4.65-4.86 4.4-.28-.03-.56-.08-.82-.17l5.68-5.68v1.45zM20.681 2.229l-13.45 13.45a6.322 6.322 0 0 1-1.65-4.28v-1.59c0-.38-.31-.69-.7-.69-.38 0-.69.31-.69.69v1.59c0 2.03.78 3.88 2.05 5.27l-4.02 4.02c-.3.3-.3.79 0 1.09.16.14.35.22.55.22.2 0 .39-.08.54-.23l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMicrophoneSlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-microphone-slash.5aff4e99e76bd534e618eddd9dbae253.svg";
export { ForwardRef as ReactComponent };